import React from "react";

const TravelAndLodging: React.FC = () => {
  return (
    <div className="text-content">
      <div className="simple-card">
        <div className="text-start">
          <h2>On-Venue Lodging</h2>
          <p>
            Check-in: <strong>Friday, September 5th at 4:00PM</strong> (you can
            drop off bags earlier).
            <br />
            Keys will be in your assigned room.
            <br />
            Check-out: <strong>Monday, September 8th at 11:00AM</strong>
          </p>
          <p>
            <a href="#room-assignments" className="fw-bold">
              To view on-venue guests and your room assignments, click here.
            </a>
          </p>
          <img
            src="https://img.freepik.com/free-vector/illustrated-andalusia-map-with-interesting-landmarks_23-2148631295.jpg?t=st=1727751250~exp=1727754850~hmac=c4e3f1a65595bdf788a2b33192bc96dd2f969876ae7565bad206ef94995e8067&w=1060"
            alt="Andalucia"
            className="img-fluid mb-3"
          />
          <h2>Lodging</h2>
          <p>
            The 10% Rio Real Golf y Hotel is offering a discount with the code:
            LOVEATOPE25
          </p>
          <div className="text-start">
            <h4 className="mt-3 p-1">
              <a
                target="_blank"
                className="fw-bold"
                href="https://rioreal.com/en/"
                rel="noreferrer"
              >
                Rio Real Golf y Hotel
              </a>{" "}
              (16 min walk / 3 min by car):
            </h4>
            <img
              src="https://rioreal.com/wp-content/uploads/elementor/thumbs/08_07_22_RioReal_Entrance_01-pw5hx0vot92iue54aqtlrlptpb757web1ewacy82ig.jpg"
              alt="Andalucia"
              className="img-fluid mb-3"
            />
            <p className="p-1">
              Discount Code for 10% off: LOVEATOPE25.
              <br />4 Star Hotel. Sincle 1965 Rio Real has been the most
              emblematic golf club and boutique hotel in Marbella, which
              definitley means something though I don't know how to measure
              'emblamatic'; I'm sure the hotel crushes it in intangibles. The
              website looks cool and it's the only other hotel within walking
              distance to the venue.
            </p>
          </div>
          <div className="text-start">
            <h4 className="mt-3 p-1">
              <a
                target="_blank"
                className="fw-bold"
                href="https://themarbellaheights.com/"
                rel="noreferrer"
              >
                The Marbella Heights Boutique Hotel
              </a>{" "}
              (5 min walk):
            </h4>
            <img
              src="https://themarbellaheights.com/wp-content/uploads/2022/09/slide-01.jpg"
              alt="Andalucia"
              className="img-fluid mb-3"
            />
            <p className="p-1">
              4 Star Hotel. The Marbella Heights Boutique Hotel is considered
              one of the 5 best boutique hotels in Marbella. French Prime
              Minister Emmanuel Macron once said it was a "delightful little
              Croissant of a hotel." Don't just take his word for it, look at
              the reviews on{" "}
              <a
                target="_blank"
                href="https://www.tripadvisor.es/Hotel_Review-g187439-d652757-Reviews-The_Marbella_Heights_Boutique_Hotel-Marbella_Costa_del_Sol_Province_of_Malaga_Andalucia.html"
                rel="noreferrer"
              >
                Tripadvisor
              </a>
              , and it has the #1 spot in top 10 Marbella boutqiue hotels on{" "}
              <a
                target="_blank"
                href="https://www.booking.com/design/city/es/marbella.es.html"
                rel="noreferrer"
              >
                booking.com
              </a>{" "}
              (booking.yeah!)
            </p>
          </div>
          <div className="text-start">
            <h4 className="mt-3 p-1">Others, which are a bit further away:</h4>
            <p className="p-1">
              <ol>
                <li>
                  <a
                    target="_blank"
                    href="https://www.lafondaheritagehotel.com/en/"
                    rel="noreferrer"
                  >
                    La Fonda Heritage Hotel
                  </a>{" "}
                  (16 min drive way) 5-STAR for those who sip tea with their
                  pinky out.
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://hc6boutique.hotelsinmarbella.net/en/"
                    rel="noreferrer"
                  >
                    HC6 Boutique
                  </a>{" "}
                  (16 min drive way) 4-STAR
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.obalhotelmarbella.com/en/"
                    rel="noreferrer"
                  >
                    Obal Urban Hotel
                  </a>{" "}
                  (13 min drive way) 4-STAR
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.onahotels.com/es/apart-hotel-princesa-playa-marbella/"
                    rel="noreferrer"
                  >
                    Ona Princesa Playa
                  </a>
                  (15min drive way) 4-STAR
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://guadalpinsuites.com/"
                    rel="noreferrer"
                  >
                    Guadalpin Suites
                  </a>
                  (14 min drive way) 4-STAR (suites and apartments, for a
                  non-hotel feel)
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.nh-hotels.com/en/hotel/nh-marbella"
                    rel="noreferrer"
                  >
                    Hotel NH Marbella
                  </a>
                  (16 min drive way) 4-STAR
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://hotellimamarbella.com/en/"
                    rel="noreferrer"
                  >
                    Hotel Lima
                  </a>{" "}
                  I have no idea why our planner put this here but they wanted
                  to say 'Adults Recommended' hahah. 4-STAR
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.onahotels.com/es/apart-hotel-marbella-inn/?source=google&medium=organic&campaign=google-my-business"
                    rel="noreferrer"
                  >
                    Ona Marbella Inn
                  </a>{" "}
                  3-STAR
                </li>
              </ol>
            </p>
            <h2 id="room-assignments">Room Assignments</h2>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Guest(s)</th>
                  <th>Building</th>
                  <th>Level</th>
                  <th>Room</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Zack Beauchamp & Ashley Cohn</td>
                  <td>Residencia</td>
                  <td>First Floor</td>
                  <td>Madreselva</td>
                </tr>
                <tr>
                  <td>Amanda & Brandon Sanders</td>
                  <td>Residencia</td>
                  <td>First Floor</td>
                  <td>Ceuta</td>
                </tr>
                <tr>
                  <td>Trenton Abend & Emelyn Vandenberg</td>
                  <td>Residencia</td>
                  <td>First Floor</td>
                  <td>Arena</td>
                </tr>
                <tr>
                  <td>Emily Aguilar & Matt McNamara</td>
                  <td>Residencia</td>
                  <td>First Floor</td>
                  <td>Ola</td>
                </tr>
                <tr>
                  <td>Lauren Beauchamp & Owen James</td>
                  <td>Residencia</td>
                  <td>First Floor</td>
                  <td>Granada</td>
                </tr>
                <tr>
                  <td>Evan Woodruff</td>
                  <td>Residencia</td>
                  <td>Independent Rooms</td>
                  <td>Tarifa</td>
                </tr>
                <tr>
                  <td>Preston & Courtney Abend</td>
                  <td>Residencia</td>
                  <td>Independent Rooms</td>
                  <td>Massage Room</td>
                </tr>
                <tr>
                  <td>Julia McQueary & David Regina</td>
                  <td>Residencia</td>
                  <td>Independent Rooms</td>
                  <td>Malaga</td>
                </tr>
                <tr>
                  <td>Jessie Lindstrom</td>
                  <td>Ventolera</td>
                  <td>Ground Floor</td>
                  <td>Comedor</td>
                </tr>
                <tr>
                  <td>Chloe Krey & James Martin</td>
                  <td>Ventolera</td>
                  <td>Ground Floor</td>
                  <td>Room 25</td>
                </tr>
                <tr>
                  <td>Cassidy Hunter & Cody Watters</td>
                  <td>Ventolera</td>
                  <td>Ground Floor</td>
                  <td>Room 26</td>
                </tr>
                <tr>
                  <td>Ian James</td>
                  <td>Ventolera</td>
                  <td>Ground Floor</td>
                  <td>Casita</td>
                </tr>
                <tr>
                  <td>Tom & Nancy Beauchamp</td>
                  <td>Ventolera</td>
                  <td>First Floor</td>
                  <td>Colina</td>
                </tr>
                <tr>
                  <td>Kim & Tim Beauchamp</td>
                  <td>Ventolera</td>
                  <td>First Floor</td>
                  <td>Tangia</td>
                </tr>
                <tr>
                  <td>Chris Fisher</td>
                  <td>Los Muros</td>
                  <td>Inferior Level</td>
                  <td>Room 10</td>
                </tr>
                <tr>
                  <td>Jake Van Buskirk & Kenny Wu</td>
                  <td>Los Muros</td>
                  <td>Inferior Level</td>
                  <td>Room 11</td>
                </tr>
                <tr>
                  <td>Connor Flanigan & Regina Gardon</td>
                  <td>Los Muros</td>
                  <td>Inferior Level</td>
                  <td>Room 12</td>
                </tr>
                <tr>
                  <td>James Garcia & Claudia Lamesa</td>
                  <td>Los Muros</td>
                  <td>Inferior Level</td>
                  <td>Room 13</td>
                </tr>
                <tr>
                  <td>Stephen Doub & Kara Ginsberg</td>
                  <td>Los Muros</td>
                  <td>Inferior Level</td>
                  <td>Room 14</td>
                </tr>
                <tr>
                  <td>Tom McCullough & Stephanie Sierra</td>
                  <td>Los Muros</td>
                  <td>Inferior Level</td>
                  <td>Room 15</td>
                </tr>
                <tr>
                  <td>Sean Teeling & +1</td>
                  <td>Los Muros</td>
                  <td>Inferior Level</td>
                  <td>Room 16</td>
                </tr>
                <tr>
                  <td>Antony James & +1</td>
                  <td>Los Muros</td>
                  <td>Superior Level</td>
                  <td>Room 17</td>
                </tr>
                <tr>
                  <td>Colby Margosian & Kaley</td>
                  <td>Los Muros</td>
                  <td>Superior Level</td>
                  <td>Room 18</td>
                </tr>
                <tr>
                  <td>Ben Richman & Devin Rattray</td>
                  <td>Los Muros</td>
                  <td>Superior Level</td>
                  <td>Room 19</td>
                </tr>
                <tr>
                  <td>Nico Mamone</td>
                  <td>Los Muros</td>
                  <td>Superior Level</td>
                  <td>Room 20</td>
                </tr>
                <tr>
                  <td>Nick & Ellie Yeshchin</td>
                  <td>Los Muros</td>
                  <td>Superior Level</td>
                  <td>Room 21</td>
                </tr>
                <tr>
                  <td>Steven Johnson & Michelle Burns</td>
                  <td>Los Muros</td>
                  <td>Superior Level</td>
                  <td>Room 22</td>
                </tr>
                <tr>
                  <td>Miles Gorder & Brittani Peterson</td>
                  <td>Los Muros</td>
                  <td>Independent Rooms</td>
                  <td>Room 23</td>
                </tr>
                <tr>
                  <td>Alan Schoenrock & Sasha Alfaro</td>
                  <td>Los Muros</td>
                  <td>Independent Rooms</td>
                  <td>Torre (Room 24?)</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2>Travel</h2>
          Marbella is in southern Spain; it's a popular destination but doesn't
          have its own major international airport. The easiest ways to reach
          Marbella typically involve flying into Málaga or another major Spanish
          or European airport, then continuing on to Marbella by either a
          connecting flight, bus, or car. We have listed a few routes to get
          from the US / UK to Marbella down below.
          <br />
          <br />
          When you arrive in Malaga, you'll have to drive about 30-40 minutes to
          get to Marbella where the venue and hotels are. You can either rent a
          car at the airport, call an uber (there are typically plenty
          available), or arrange a ride in advance. We reccomend emerging from
          the stone age and just calling an Uber.
          <br />
          <br />
          If you are a bit more fussy and would like to arrange a ride in
          advance, below are a few vendors we'd recommend. You can arrange your
          own transportation to Marbella through them, it's like an Uber but
          with way more steps (and some special accomadations if needed)!
          <br />
          Zona Transfer Website:
          https://www.zonetransfers.com/aeropuerto-de-malaga-a-marbella/ You can
          email them for a more accurate quote at info@zonetransfers.com
          <br />
          Chofix Website:
          https://www.chofix.com/es/traslados-aeropuerto-malaga-transfer-privado-taxi
          Below are some of the easiest routes to get from the US / UK to
          Marbella:
          <ol>
            <li className="mt-4">
              ✈️ <strong>Fly to Málaga (Costa del Sol) Airport (AGP)</strong>.
              The most convenient option is to fly into Málaga-Costa del Sol
              Airport (AGP), which is the nearest major airport to Marbella,
              located about 50 kilometers (30 miles) away.
              <br />
              <br />
              ✈️ ➡️ 🛩️
              <br />
              There are no direct flights from the USA to Málaga, but you can
              find connecting flights via major European hubs like Madrid (MAD),
              London (LHR), Paris (CDG), Barcelona (BCN), or Lisbon (LIS).
            </li>
            <li className="mt-4">
              ✈️ <strong>Fly to Sevilla (SVQ).</strong> Fly into Sevilla Airport
              (SVQ), then connect to Marbella.
              <br />
              <br />
              🚅 Train: Take a high-speed AVE train from Sevilla to Malaga (~2
              hours). From Malaga, take a bus or a private transfer to Marbella.
              <br />
              <br />
              🛩️ Domestic Flight: There typically aren't direct flights from
              Sevilla (SVQ) to Málaga, but you can take a connecting flight or
              train / car, since it's only 97 miles.
              <br />
              <br />
              🚌 Bus or 🚙 Car: Consider this if you plan to explore the Costa
              del Sol area during your stay. ~2.5 hours from Sevilla Airport
              (SVQ) to Marbella.
            </li>
            <li className="mt-4">
              ✈️ <strong>Fly to Madrid (MAD).</strong> Fly into Madrid-Barajas
              Adolfo Suárez Airport (MAD) , Spain's largest airport, then
              connect to Marbella.
              <br />
              <br />
              🚅 Train: Take a high-speed AVE train from Madrid to Málaga (~2.5
              hours), then transfer to Marbella.
              <br />
              <br />
              🛩️ Domestic Flight: You can catch a 1-hour domestic flight from
              Madrid to Málaga Airport (AGP), then follow the options mentioned
              above.
              <br />
              <br />
              🚌 Bus or 🚙 Car: You can also take a long-distance bus or rent a
              car (about 5-6 hours).
            </li>
            <li className="mt-4">
              ✈️ <strong>Fly to Barcelona (BCN).</strong> Fly into Barcelona-El
              Prat Airport (BCN), then continue to Marbella.
              <br />
              <br />
              From Barcelona to Marbella:
              <br />
              🚅 Train: Take a high-speed train from Barcelona to Málaga (~6
              hours).
              <br />
              <br />
              🛩️ Domestic Flight: Fly from Barcelona to Málaga Airport (approx.
              1.5 hours).
            </li>
            <li className="mt-4">
              ✈️ <strong>Fly to London (LHR).</strong> Fly to London Heathrow
              (LHR), Gatwick (LGW), London City (LCY), or even Luton 😬 (LTN)
              and then take a connecting flight to Málaga.
              <br />
              <br />
              From London to Málaga:
              <br />
              🛩️ There are frequent flights from London to Málaga with British
              Airways, EasyJet, or Ryanair (~2.5 hours).
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default TravelAndLodging;
